import { cn } from "@/lib/utils";

interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  body?: string;
  align?: "left" | "center";
  className?: string;
  as?: "h1" | "h2";
  size?: "lg" | "xl";
  aside?: React.ReactNode;
}

/**
 * Standard section opener: small eyebrow, large LOGAM display title,
 * optional body line, optional aside. No magazine vocabulary.
 */
export function SectionHeading({
  eyebrow,
  title,
  body,
  align = "left",
  className,
  as = "h2",
  size = "lg",
  aside,
}: SectionHeadingProps) {
  const H = as;
  const sizeClass = size === "xl" ? "display-xl" : "display-lg";
  return (
    <div className={cn("flex flex-col gap-4 sm:gap-5", align === "center" && "text-center items-center", className)}>
      {eyebrow && <span className="eyebrow text-[var(--cream)]">{eyebrow}</span>}

      <div
        className={cn(
          "flex w-full items-end gap-4 sm:gap-6",
          align === "center" ? "justify-center" : "justify-between",
        )}
      >
        <H className={cn(sizeClass, "max-w-[20ch]")}>{title}</H>
        {aside && align !== "center" && <div className="hidden md:block shrink-0 pb-3">{aside}</div>}
      </div>

      {body && (
        <p
          className={cn(
            "max-w-[60ch] text-[14.5px] leading-[1.65] text-[var(--text-soft)] sm:text-[15.5px] sm:leading-[1.7]",
            align === "center" && "mx-auto",
          )}
        >
          {body}
        </p>
      )}

      {aside && align !== "center" && <div className="md:hidden">{aside}</div>}
    </div>
  );
}
